// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sub-menu__item[data-v-0c37507e] {
      display: flex;
      justify-content: space-between;
      gap: 1rem;
}
@media (min-width: 996px) {
.sub-menu__item[data-v-0c37507e] {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            padding-top: 1rem;
            padding-bottom: 1rem;
}
.sub-menu__item[data-v-0c37507e]:hover {
            --tw-bg-opacity: 1;
            background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
}
.sub-menu__item[data-v-0c37507e]:first-of-type {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
}
.sub-menu__item[data-v-0c37507e]:last-of-type {
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
}
.sub-menu__item[data-v-0c37507e]:not(:hover) {
      transition: padding-left 0.5s ease;
}
.sub-menu__item[data-v-0c37507e]:hover {
      --tw-text-opacity: 1;
      color: rgb(200 143 0 / var(--tw-text-opacity));
}
@media (min-width: 996px) {
.sub-menu__item[data-v-0c37507e]:hover {
            --tw-bg-opacity: 1;
            background-color: rgb(250 237 205 / var(--tw-bg-opacity));
            padding-left: 3rem;
}
}
.sub-menu__item[data-v-0c37507e]:hover:before {
      position: absolute;
      left: 1rem;
}
@media (min-width: 996px) {
.sub-menu__item[data-v-0c37507e]:hover:before {
            --tw-content: '\\2192';
            content: var(--tw-content);
}
}
.sub-menu__link[data-v-0c37507e] {
      display: flex;
      width: 100%;
      justify-content: space-between;
}
@media (min-width: 996px) {
.sub-menu__link[data-v-0c37507e] {
            width: -moz-fit-content;
            width: fit-content;
}
.sub-menu__icon.icon[data-v-0c37507e] {
            display: none;
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/menus/SubMenuItem.vue"],"names":[],"mappings":";AAqDA;MAAA,aAAA;MAAA,8BAAA;MAAA,SAAA;AAAA;AAAA;AAAA;YAAA,oBAAA;YAAA,qBAAA;YAAA,iBAAA;YAAA,oBAAA;AAAA;AAAA;YAAA,kBAAA;YAAA,yDAAA;AAAA;AAAA;AAGA;MAAA,2BAAA;MAAA,4BAAA;AAAA;AAGA;MAAA,+BAAA;MAAA,8BAAA;AAAA;AAEA;MACA,kCAAA;AACA;AAEA;MAAA,oBAAA;MAAA,8CAAA;AAAA;AAAA;AAAA;YAAA,kBAAA;YAAA,yDAAA;YAAA,kBAAA;AAAA;AAAA;AAGA;MAAA,kBAAA;MAAA,UAAA;AAAA;AAAA;AAAA;YAAA,qBAAA;YAAA,0BAAA;AAAA;AAAA;AAKA;MAAA,aAAA;MAAA,WAAA;MAAA,8BAAA;AAAA;AAAA;AAAA;YAAA,uBAAA;YAAA,kBAAA;AAAA;AAGA;YAAA,aAAA;AAAA;AAHA","sourcesContent":["<template>\n  <li class=\"sub-menu__item\" v-hover=\"{ cb: hover, args: [BRAND_PRIMARY_DARKEST] }\">\n    <a :href=\"href\" class=\"sub-menu__link\">\n      <slot></slot>\n      <Icon v-if=\"!!icon\" class=\"sub-menu__icon\" :name=\"icon\" :size=\"iconSize\" :color=\"iconColor\" />\n    </a>\n  </li>\n</template>\n\n<script>\nimport { ref } from '@vue/composition-api';\nimport { Link } from '@inertiajs/inertia-vue';\nimport Icon from '@/lego/components/icons/Icon.vue';\n\nconst BRAND_PRIMARY_DARKEST = '#C88F00';\n\nexport default {\n  components: {\n    Link,\n    Icon,\n  },\n  props: {\n    href: {\n      type: String,\n      required: true,\n    },\n    icon: {\n      type: String,\n    },\n    iconSize: {\n      type: Number,\n      default: 20,\n    },\n  },\n  setup() {\n    var iconColor = ref('black');\n\n    function hover(el, color) {\n      iconColor.value = color ?? 'black';\n    }\n\n    return {\n      iconColor,\n      hover,\n      BRAND_PRIMARY_DARKEST,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.sub-menu {\n  &__item {\n    @apply flex justify-between gap-xxxs lg:hover:bg-neutral-lightest lg:px-xxs lg:py-xxxs;\n\n    &:first-of-type {\n      @apply rounded-t-s;\n    }\n    &:last-of-type {\n      @apply rounded-b-s;\n    }\n    &:not(:hover) {\n      transition: padding-left 0.5s ease;\n    }\n    &:hover {\n      @apply text-brand-primary-darkest lg:bg-brand-primary-lightest lg:pl-md;\n\n      &:before {\n        @apply absolute left-xxxs lg:content-['\\2192'];\n      }\n    }\n  }\n  &__link {\n    @apply flex justify-between w-full lg:w-fit;\n  }\n  &__icon.icon {\n    @apply lg:hidden;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
